module.exports = __webpack_public_path__ + "static/img/74hc32-1.fae27f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/74hc32-1.svg
// module id = bN91
// module chunks = 0